// extracted by mini-css-extract-plugin
module.exports = {"btnWrapper":"resetPasswordModal_btnWrapper__2cUqX","succesWrpper":"resetPasswordModal_succesWrpper__t2riX","header":"resetPasswordModal_header__1aYF2"};